/* This method generates Name Permutation based on the First Name, Middle Name, and Last Name */
export const getNamePermutations = (props) => {
  const {
    dataObject,
    functionObject,
  } = props;
  const { formSubmissionPayload } = dataObject;
  const { setFormSubmissionPayload } = functionObject;
  const arrNameOnCard = [];
  if (formSubmissionPayload.firstName !== '') {
    if (formSubmissionPayload.middleName && formSubmissionPayload.middleName !== '') {
      arrNameOnCard.push(
        `${formSubmissionPayload.firstName.toUpperCase()} ${formSubmissionPayload.middleName.toUpperCase()} ${formSubmissionPayload.lastName.toUpperCase()}`,
        `${formSubmissionPayload.firstName.toUpperCase()} ${formSubmissionPayload.middleName.charAt(0)
          .toUpperCase()} ${formSubmissionPayload.lastName.toUpperCase()}`,
        `${formSubmissionPayload.firstName.charAt(0)
          .toUpperCase()} ${formSubmissionPayload.middleName.charAt(0)
          .toUpperCase()} ${formSubmissionPayload.lastName.toUpperCase()}`,
        `${formSubmissionPayload.firstName.charAt(0)
          .toUpperCase()} ${formSubmissionPayload.middleName.toUpperCase()} ${formSubmissionPayload.lastName.toUpperCase()}`,
        `${formSubmissionPayload.firstName.toUpperCase()} ${formSubmissionPayload.middleName.charAt(0)
          .toUpperCase()} ${formSubmissionPayload.lastName.charAt(0)
          .toUpperCase()}`
      );
    }
    arrNameOnCard.push(
      `${formSubmissionPayload.firstName.toUpperCase()} ${formSubmissionPayload.lastName.toUpperCase()}`,
      `${formSubmissionPayload.firstName.charAt(0)
        .toUpperCase()} ${formSubmissionPayload.lastName.toUpperCase()}`,
      `${formSubmissionPayload.firstName.toUpperCase()} ${formSubmissionPayload.lastName.charAt(0)
        .toUpperCase()}`,
      formSubmissionPayload.firstName.toUpperCase()
    );
    let arrLength = arrNameOnCard.length;
    while (arrLength > 0) {
      arrLength -= 1;
      if (arrNameOnCard[arrLength].length > 17) arrNameOnCard.splice(arrLength, 1);
    }

    // filter duplicate  elements:
    const arrUniqueNameOnCard = [...new Set(arrNameOnCard)];
    const uniqueNameOnCardObj = arrUniqueNameOnCard.map((item) => ({ name: item }));
    setFormSubmissionPayload((prevPayload) => ({
      ...prevPayload,
      nameOnCard: uniqueNameOnCardObj,
      elemId: '',
    })
    );
  }
};
